import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Row from './Row';

class RowGroup extends PureComponent {
  state = {
    isShowRow: true,
  };

  toggleShowRow = () => {
    const { item, onToggleRow } = this.props;
    if (!item.canToggle) {
      return;
    }
    this.setState(
      prev => ({
        isShowRow: !prev.isShowRow,
      }),
      () => {
        onToggleRow(this.state.isShowRow);
      },
    );
  };

  getGroupTd = () => {
    const { isShowRow } = this.state;
    const { item, schema, stickyFirstColumn } = this.props;
    let content = '';
    if (stickyFirstColumn) {
      content = (
        <>
          <td colSpan={1}>
            <div className="group-list-date">{item.renderTitle(isShowRow)}</div>
          </td>
          <td colSpan={schema.length - 1} />
        </>
      );
      return content;
    }
    content = (
      <td colSpan={schema.length}>
        <div className="group-list-date">{item.renderTitle(isShowRow)}</div>
      </td>
    );
    return content;
  };

  render() {
    const { isShowRow } = this.state;
    const {
      item,
      schema,
      getDataFromRedux,
      stickyFirstColumn,
      widths,
      tdPadding,
      clickRow,
    } = this.props;

    return (
      <>
        <tr onClick={this.toggleShowRow} style={item.rowStyle || {}}>
          {this.getGroupTd()}
        </tr>
        {isShowRow &&
          item.ids.map((id, rowIndex) => (
            <tr onClick={() => clickRow(id)} className="group-id" key={id}>
              <Row
                tdPadding={tdPadding}
                widths={widths}
                rowIndex={rowIndex}
                getDataFromRedux={getDataFromRedux}
                id={id}
                schema={schema}
                stickyFirstColumn={stickyFirstColumn}
              />
            </tr>
          ))}
      </>
    );
  }
}

RowGroup.propTypes = {
  schema: PropTypes.array.isRequired,
  item: PropTypes.object.isRequired,
  getDataFromRedux: PropTypes.func.isRequired,
};

export default RowGroup;
